import { SortDirection } from '@angular/material/sort';

export interface SortOptions {
  enabled?: boolean;
  disableClear?: boolean;
  start?: SortDirection;
}
